import React from 'react';
import radium from 'radium';
import { ThemeContext } from '../theme/Theme.jsx';

// Styles
import './ZigZagBox.scss';

function ZigZagBox(props) {
	const context = React.useContext(ThemeContext);
	const style = {
		zigZagBox: {
			margin: context.themeManager
				.value('zig-zag-box', 'margin-mobile', 'zig-zag-box-margin-mobile'),
			background: context.themeManager
				.value('zig-zag-box', 'background', 'bg-color-zig-zag-box'),
			color: context.themeManager
				.value('zig-zag-box', 'color', 'fg-color-text'),
			padding: context.themeManager
				.valueOrDefault('zig-zag-box', 'padding-mobil', null, '1em'),
			'@media(min-width : 768px)': {
				padding: context.themeManager
					.valueOrDefault('zig-zag-box', 'padding-desktop', null, '2.5em 3em 2em'),
				margin: context.themeManager
					.value('zig-zag-box', 'margin-mobile', 'zig-zag-box-margin-desktop'),
			},
		},
		zigZagBoxTop: {
			backgroundImage: 'linear-gradient(45deg, transparent 34%, ' + context.themeManager
				.value('zig-zag-box', 'background', 'bg-color-zig-zag-box') + ',  ' + context.themeManager
				.value('zig-zag-box', 'background', 'bg-color-zig-zag-box') + ' 66%, transparent 66%),linear-gradient(315deg, transparent 34%,  ' + context.themeManager
				.value('zig-zag-box', 'background', 'bg-color-zig-zag-box') + ' 34%,  ' + context.themeManager
				.value('zig-zag-box', 'background', 'bg-color-zig-zag-box') + ' 66%, transparent 66%)'
		}
	};
	return props.children ? (
		<div className="zig-zag-box" style={style.zigZagBox} {...(props.id ? {id: props.id} : {})}>
			<div className="zig-zag-box--top" style={style.zigZagBoxTop}/>
			{props.children}
		</div>
	) : null;
}

export default radium(ZigZagBox);
